/* Keep storefront links in Shopify's rendered language, including rich text and async cards. */
(() => {
  const config = document.currentScript.dataset;
  const root = (config.rootUrl || '/').replace(/\/$/, '');
  if (!root) return;
  const hosts = new Set([location.hostname, ...(config.storeHosts || '').split(',')].map(h => h.replace(/^www\./, '')));
  function localize(anchor) {
    if (!anchor.matches('a[href]') || anchor.hasAttribute('hreflang') || anchor.hasAttribute('download')) return;
    const raw = anchor.getAttribute('href');
    if (!raw || raw.startsWith('#') || !/^(?:https?:|\/|\?|[^:]+$)/i.test(raw)) return;
    let target;
    try { target = new URL(raw, location.href); } catch (_) { return; }
    if (!['http:', 'https:'].includes(target.protocol) || !hosts.has(target.hostname.replace(/^www\./, ''))) return;
    // Already-localized links and non-storefront destinations are intentionally untouched.
    if (!/^\/(?:$|(?:products|collections|pages|blogs|policies)(?:\/|$)|(?:search|cart)\/?$)/.test(target.pathname)) return;
    anchor.setAttribute('href', root + (target.pathname === '/' ? '' : target.pathname) + target.search + target.hash);
  }
  function scan(node) {
    if (node.nodeType !== 1 && node !== document) return;
    if (node.matches?.('a[href]')) localize(node);
    node.querySelectorAll('a[href]').forEach(localize);
  }
  scan(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') localize(record.target);
      else record.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  ['click', 'auxclick'].forEach(type => document.addEventListener(type, event => {
    const anchor = event.target.closest?.('a[href]');
    if (anchor) localize(anchor);
  }, true));
})();
